import { v4 as uuidv4 } from 'uuid'

export function generateRoomCode() {
  return uuidv4().replace(/-/g, '').substring(0, 8).toUpperCase()
}

export function buildInviteUrl(roomId) {
  const base = import.meta.env.VITE_APP_URL || window.location.origin
  return `${base}/room/${roomId}`
}

export async function copyToClipboard(text) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text)
  } else {
    const el = document.createElement('textarea')
    el.value = text
    el.style.position = 'absolute'
    el.style.opacity = '0'
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
  }
}

export function formatMoveLabel(moveNumber, color, san) {
  if (color === 'w') return `${moveNumber}. ${san}`
  return `${moveNumber}... ${san}`
}

export function truncate(str, maxLen = 30) {
  if (!str) return ''
  return str.length <= maxLen ? str : `${str.substring(0, maxLen)}…`
}

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export function isMobile() {
  return window.innerWidth < 768
}

export function isMediaSupported() {
  return !!(navigator.mediaDevices?.getUserMedia)
}
